import { apiInstance } from '@api/api'
import type { ApiReturnType, ErrorResponse } from '@api/types'
import { useAuthStore } from '@core/stores/auth-store'
import { setUser } from '@sentry/react'
import { queryOptions, useQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

type Path = '/auth/self'

type Data = ApiReturnType<Path, 'get', 200>

export function getAuthSelfQueryKey() {
  return ['auth', 'self', 'get'] as const
}

async function getAuthSelf() {
  const { data } = await apiInstance.get<Data>('/auth/self')
  setUser({ id: data.user.id, email: data.user.email })
  return data
}

export function getAuthSelfQueryOptions() {
  return queryOptions<Data, AxiosError<ErrorResponse>>({
    queryKey: getAuthSelfQueryKey(),
    queryFn: getAuthSelf,
    enabled: () => useAuthStore.getState().isLogged(),
    retry: false,
    staleTime: Infinity,
    gcTime: Infinity,
  })
}

export function useGetAuthSelf() {
  return useQuery(getAuthSelfQueryOptions())
}
